import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

@NgModule({
    declarations: [ForgotPasswordComponent, ResetPasswordComponent],
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class ForgotPasswordModule {}
